import { BaseStore } from 'fluxible/addons';
import Actions from '../constants/Actions';
import { defineMessages } from 'react-intl';
import Immutable from 'immutable';

const SITE_NAME = 'Ignite Sales Customer Portal';
const BASE_URL = 'http://localhost.com';

const messages = defineMessages({
  author: {
    id: 'meta.author',
    defaultMessage: 'Austen Holmes',
    description: 'The author of this site'
  },
  description: {
    id: 'meta.description',
    defaultMessage: 'Ignite Sales Customer Portal',
    description: 'The default description for the site\'s home page'
  },
  errorTitle: {
    id: 'meta.title.error',
    defaultMessage: 'Error displaying this page',
    description: 'The default page title for the html head element when there is an error loading the page'
  },
  loadingTitle: {
    id: 'meta.title.loading',
    defaultMessage: 'Loading...',
    description: 'The default page title for the html head element when the site is currently loading'
  },
  notFoundTitle: {
    id: 'meta.title.notFound',
    defaultMessage: 'Page not found',
    description: 'The default page title for the html head element when the current page cannot be found'
  },
  title: {
    id: 'meta.title',
    defaultMessage: 'Ignite Sales Customer Portal',
    description: 'The default page title for the html head element'
  }
});

const emptyExtendedMessages = {
  title: null,
  description: null
};

/*
This store listens to fluxible-router's actions and keep
the content for the <head> tag. Used in components/Html.js,
and Application.js (to change the document's title)
 */
class HtmlHeadStore extends BaseStore {
  static storeName = 'HtmlHeadStore';

  static handlers = {
    [Actions.NAVIGATION__STARTED]: 'handleNavigateStart',
    [Actions.NAVIGATION__COMPLETED]: 'handleNavigateSuccess',
    [Actions.NAVIGATION__FAILED]: 'handleNavigateFailure',
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.siteName = SITE_NAME;
    this.setInitialState();

    this.script = document.createElement('script');
    this.script.src =
      'https://ignitesales.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-egccmf/b/24/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=f2f8532a';
    this.script.async = true;
    this.script.onload = () => this.onScriptLoad();
    document.head.appendChild(this.script);
  }

  onScriptLoad = () => {
    /* eslint-disable no-undef */
    window.ATL_JQ_PAGE_PROPS = $.extend(window.ATL_JQ_PAGE_PROPS, {
      triggerFunction: function (showCollectorDialog) {
        $('#jira-feedback').on('click', function (e) {
          e.preventDefault();
          showCollectorDialog();
        });
      },
      fieldValues: {
        // Security Level = Internal
        security: '10001',
      },
    });
    /* eslint-enable no-undef */
  };

  setInitialState() {
    this.titleMessage = messages.title;
    this.descriptionMessage = messages.description;
    this.authorMessage = messages.author;
    this.extendedMessages = emptyExtendedMessages;
    this.navigationComplete = true;
    this.timezone = 12 - new Date().getTimezoneOffset() / 60;
  }

  getTimezone() {
    return this.timezone;
  }

  setTimezone(tz) {
    this.timezone = tz;
    return this;
  }

  getTitleMessage() {
    return this.titleMessage;
  }

  getExtendedMessages() {
    return this.extendedMessages;
  }

  getDescriptionMessage() {
    return this.descriptionMessage;
  }

  getAuthorMessage() {
    return this.authorMessage;
  }

  getSiteName() {
    return this.siteName;
  }

  getCurrentUrl() {
    return `${BASE_URL}${this.dispatcher
      .getStore('RouteStore')
      .getCurrentUrl()}`;
  }

  isNavigationComplete() {
    return this.navigationComplete;
  }

  handleNavigateStart() {
    // Use a loading title when loading the route
    this.extendedMessages = {
      title: messages.loadingTitle,
    };
    this.navigationComplete = false;
    this.emitChange();
  }

  // Set the store content (images, description, title, etc.) according to the received route
  // Remember: route is an immutable object!
  handleNavigateSuccess(payload) {
    const routes = Immutable.Seq(payload.routes);
    const lastMeta = routes.findLast((r) => {
      return r.meta;
    });
    if (lastMeta) {
      console.info('Setting extended messages from HtmlHeadStore');
      this.extendedMessages = lastMeta.meta;
    } else {
      console.info('Clearing extended messages from HtmlHeadStore');
      this.extendedMessages = emptyExtendedMessages;
    }
    this.navigationComplete = true;

    this.emitChange();
  }

  handleNavigateFailure(error) {
    if (error.statusCode === 404) {
      this.extendedMessages = {
        title: messages.notFoundTitle,
      };
    } else {
      this.extendedMessages = {
        title: messages.errorTitle,
      };
    }
    this.navigationComplete = true;
    this.emitChange();
  }

  dehydrate() {
    return {
      titleMessage: this.titleMessage,
      descriptionMessage: this.descriptionMessage,
      authorMessage: this.authorMessage,
      extendedMessages: this.extendedMessages,
    };
  }

  rehydrate({
    titleMessage,
    descriptionMessage,
    authorMessage,
    extendedMessages,
  }) {
    this.titleMessage = titleMessage || messages.title;
    this.descriptionMessage = descriptionMessage || messages.description;
    this.authorMessage = authorMessage || messages.author;
    this.extendedMessages = extendedMessages;
  }
}

export default HtmlHeadStore;



// WEBPACK FOOTER //
// ./src/stores/HtmlHeadStore.js